/* eslint-disable */
import CloseIcon from '@mui/icons-material/Close'
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  IconButton,
  MenuItem,
  Modal,
  OutlinedInput,
  Select,
  TextField,
  Typography
} from '@mui/material'
// import CircularProgress from '@mui/material/CircularProgress'
import React, { useEffect, useRef, useState } from 'react'
import ApiService from '../../../../ApiService.js'
import {
  CREATE_TRIP_URL,
  SELECTED_ROUTE_URL,
  TRIP_SUMMARY_URL
} from '../../../../constants.js'

import { useViewPort } from '../../../.././ViewportProvider.js'
import { useStates } from '../../../../StateProvider.js'
import { useEmulatorStore } from '../../../../stores/emulator/store.tsx'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import '../../../../scss/gps.scss'
import { generateTripPoint } from '../../../../stores/emulator/SelectedEmulatorData.tsx'
import ArrivalDateTimeFieldValue from './ArrivalDateTimeFieldValue.tsx'
import DepartureDateTimeFieldValue from './DepartureDateTimeFieldValue.tsx'
import FromSearchBar from './FromSearchBar.js'
import ToSearchBar from './ToSearchBar.js'

const CreateTripDialog = () => {
  const setDefaultTripPoints = useEmulatorStore(
    (state) => state.setDefaultPathPoints
  )
  const setAlternativeTripPoints = useEmulatorStore(
    (state) => state.setAlternativePathPoints
  )

  // For selected route from multiple route
  const setSelectedRouteDetailsSubmit = useEmulatorStore(
    (state) => state.setSelectedRouteDetails
  )

  /* set index for selected route */
  const setSelectPathIndex = useEmulatorStore(
    (state) => state.setSelectPathIndex
  )

  dayjs.extend(utc)
  const { width } = useViewPort()
  const breakpoint = 620
  const isMobile = width < breakpoint

  const { isTableVisible, isTableGetSummary } = useStates()

  const connectedEmulatorRef = useRef(
    useEmulatorStore.getState().connectedEmulator
  )

  const draggedEmulatorsRef = useRef(
    useEmulatorStore.getState().draggedEmulators
  )

  useEffect(() => {
    useEmulatorStore.subscribe(
      (state) => state.connectedEmulator,
      (connectedEmulator) => (connectedEmulatorRef.current = connectedEmulator)
    )
  }, [])

  useEffect(() => {
    useEmulatorStore.subscribe(
      (state) => state.draggedEmulators,
      (draggedEmulators) => {
        draggedEmulatorsRef.current = draggedEmulators
      }
    )
  }, [])

  const [fromLat, setFromLat] = useState()
  const [fromLong, setFromLong] = useState()
  const [toLat, setToLat] = useState()
  const [toLong, setToLong] = useState()
  const [fromAddress, setFromAddress] = useState('')
  const [toAddress, setToAddress] = useState('')
  const [inputValue, setInputValue] = useState('')

  const [departTime, setDepartTime] = React.useState('')
  const [departNow, setDepartNow] = React.useState(false)
  const [arrivalTime, setArrivalTime] = React.useState('')
  const [arrivalTimeOffSet, setArrivalTimeOffset] = React.useState('')
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  // const [team, setTeam] = useState(localStorage.getItem('team') ?  localStorage.getItem('team') : false)
  const [team, setTeam] = useState(false)
  const [routeChoose, setRouteChoose] = useState('All')
  const [speedChange, setSpeedChange] = useState('')
  const [utcFromOffset, setUtcFromOffset] = useState('')
  const [utcToOffset, setUtcToOffset] = useState('')
  const [fromTimeZone, setFromTimeZone] = useState('UTC') //  default to UTC
  const [toTimeZone, setToTimeZone] = useState('UTC') //  default to UTC
  const [toOffsetFromUtcInMs, setToOffsetFromUtcInMs] = useState('')
  const [fromOffsetFromUtcInMs, setFromOffsetFromUtcInMs] = useState('')
  const [compareArrivalTime, setCompareArrivalTime] = useState()

  const { setIsTableVisible, showToast } = useStates()
  const [multipleRoutes, setMultipleRoutes] = useState({
    dafault: 0,
    alternatives: 0
  })

  const [updateRouteTeamCheckbox, setUpdateRouteTeamCheckbox] = useState({
    updatedRoute: 0,
    updatedRouteForMap: 0
  })

  const [alternativeShapes, setAlternativeShapes] = useState([])
  const [defaultShapes, setDefaultShapes] = useState([])

  const handleClose = () => {
    setIsTableVisible(false)
  }

  const handleInputChange = (event) => {
    setInputValue(event.target.value)
  }

  useEffect(() => {
    // Default trip points
    if (fromAddress === null || toAddress === null) {
      setDefaultTripPoints(0)
      setAlternativeTripPoints([0])
      const updatedSelectedRouteDetails = {
        alternativeRoute: ''
      }
      setSelectedRouteDetailsSubmit(updatedSelectedRouteDetails)
    } else {
      const extraDefaultTripPoints = generateTripPoint(defaultShapes)
      setDefaultTripPoints(extraDefaultTripPoints)
      // Extract alternative trip points
      const extraAlternativeTripPoints = alternativeShapes?.map(
        (alt, index) => {
          return generateTripPoint(alt)
        }
      )
      setAlternativeTripPoints(extraAlternativeTripPoints)
    }
  }, [alternativeShapes, defaultShapes, fromAddress, toAddress])

  const handleDraggedEmulatorsIfAny = () => {
    const connectedEmulator = connectedEmulatorRef.current
    if (connectedEmulator !== null) {
      // if draggedEmulators is not null, then find from draggedEmulators where id is equal to connectedEmulator.id
      const draggedEmulatorsList = draggedEmulatorsRef.current
      let didRemove = false
      draggedEmulatorsList.forEach((draggedEmulator, index) => {
        if (draggedEmulator.emulator.id === connectedEmulator.id) {
          draggedEmulatorsList.splice(index, 1)
          didRemove = true
        }
      })
      if (didRemove) {
        useEmulatorStore.setState({
          draggedEmulators: [...draggedEmulatorsList]
        })
      }
    }
  }

  useEffect(() => {
    if (fromAddress === null || toAddress === null) {
      setMultipleRoutes({
        ...multipleRoutes,
        dafault: 0,
        alternatives: 0
      })
      localStorage.setItem('breaksNRestDetails', null)
    }
  }, [toAddress, fromAddress])

  useEffect(()=> {
    // Remove stops and breaks on page reload
    localStorage.setItem('breaksNRestDetails', null)
  },[])

  useEffect(() => {
    if (!fromLat || !fromLong || !toLat || !toLong) {
      // setDefaultShapes('')
      return
    }

    const payload = {
      startLong: fromLong,
      startLat: fromLat,
      endLong: toLong,
      endLat: toLat
    }

    const fetchSelectedRoute = async () => {
      const token = localStorage.getItem('token')

      try {
        const { success, data, error } = await ApiService.makeApiCall(
          SELECTED_ROUTE_URL,
          'POST',
          payload,
          token,
          null
        )

        if (success) {
          // const extraDefaultTripPoints = generateTripPoint(data.trip.legs[0].shape)
          if (data?.alternates?.length > 0) {
            // Extract alternative shapes dynamically
            const extractedShapes = data?.alternates?.map(
              (alt) => alt?.trip.legs[0].shape
            )
            setAlternativeShapes(extractedShapes)
          }
          setDefaultShapes(data.trip.legs[0].shape)

          setMultipleRoutes((prev) => ({
            ...prev,
            default: 1,
            alternatives: data?.alternates?.length || 0
          }))
        } else {
          console.error('Error:', error)
        }
      } catch (error) {
        console.error('API error:', error)
      }
    }

    // Debounce with setTimeout
    const timeout = setTimeout(fetchSelectedRoute, 1000)

    return () => clearTimeout(timeout) // Cleanup previous timeout before setting a new one
  }, [fromLat, fromLong, toLat, toLong])

  const handleCreateTripClick = async () => {
    const actualTime = new Date(compareArrivalTime)
    const selectedTime = new Date(dayjs(arrivalTime))
    // if(actualTime  <= selectedTime){
    if ((!fromLat && !fromLong) || (!toLat && !toLong)) {
      showToast('Please fill both locations!', 'error')
      return
    }

    setError('')

    let updatedRoute
    if (routeChoose !== '') {
      updatedRoute = routeChoose === 'Default' ? 0 : routeChoose
    }
    let confirmed = false
    const connectedEmulator = connectedEmulatorRef.current
    if (connectedEmulator === null) {
      showToast('Please connect to an emulator!', 'error')
      return
    }
    if (
      connectedEmulator.startLat !== null &&
      connectedEmulator.tripStatus !== 'STOP'
    ) {
      confirmed = window.confirm(
        'Creating new Trip will remove running trip for this emulator!! Continue?'
      )
    } else {
      confirmed = true
    }
    const updateDepartTime = dayjs(departTime)
    const localOffsetFromUtcInMs = dayjs().utcOffset() * 60 * 1000;
    const fakeArrivalTimeInUtc = arrivalTime.unix() * 1000
    const fakeDepartTimeInUtc = departNow ? dayjs().unix() * 1000 : dayjs(departTime).unix() * 1000

    console.log('arrivalTime', arrivalTime)
    console.log('departTime', departTime)
    console.log('fakeDepartTimeInUtc', fakeDepartTimeInUtc)
    console.log('fakeArrivalTimeInUtc', fakeArrivalTimeInUtc)

    if (confirmed) {
      setIsLoading(true)
      const payload = {
        startLat: fromLat,
        startLong: fromLong,
        endLat: toLat,
        endLong: toLong,
        fromAddress,
        toAddress,
        emulatorDetailsId: connectedEmulator.id,
        fakeDepartTimeInUtc: fakeDepartTimeInUtc,
        fakeArrivalTimeInUtc: fakeArrivalTimeInUtc,
        departNow,
        team: team,
        selectedTripIndex: updatedRoute,
        speed: {
          speedUnit: 'MPH',
          value: Number(speedChange) || 35.0
        }
      }
      const token = localStorage.getItem('token')
      const { success, error } = await ApiService.makeApiCall(
        CREATE_TRIP_URL,
        'POST',
        payload,
        token
      )
      if (success) {
        showToast('Trip Added successfully', 'success')
        // fetchEmulators()
        handleDraggedEmulatorsIfAny()
        handleClose()
        const updatedSelectedRouteDetails = {
          alternativeRoute: ''
        }
        setSpeedChange('')
        setTeam(false)
        setRouteChoose('All')
        setSelectedRouteDetailsSubmit(updatedSelectedRouteDetails)
        localStorage.setItem('team', false)
        localStorage.setItem('breaksNRestDetails', null)
      } else {
        showToast(error, 'error')
      }
      setIsLoading(false)
    }
    /* Remove from and to address from localStorage */
    localStorage.setItem('fromSearchAddress', '')
    localStorage.setItem('toSearchAddress', '')
  // }
  // else {
  //   showToast('The trip cannot be created as the arrival time is too short', 'error')
  // }
}

  const ITEM_HEIGHT = 48
  const ITEM_PADDING_TOP = 8
  const MenuProps = {
    PaperProps: {
      sx: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP, // Fixed maxHeight calculation
        width: 250,
        '&::-webkit-scrollbar': {
          width: '8px'
        },
        '&::-webkit-scrollbar-track': {
          background: '#ffff'
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#212529',
          borderRadius: '4px'
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: '#212529'
        }
      }
    },
    ListProps: {
      sx: {
        fontSize: '12px',
        fontFamily: "'Poppins', sans-serif !important",
        fontWeight: '400'
      }
    }
  }

  /* Calling Get Summary to select route from multiple one */
  const getSummaryOfRoute = async (
    alternativeRoute,
    updatedRouteForMap,
    teamParam
  ) => {
    const updateDepartTime = dayjs(departTime)

    // Convert to ISO string and remove timezone offset
    const localTimeZone = dayjs.tz.guess()
    console.log('localTimeZone', localTimeZone)
    const currentTimeInLocalTimeZone = dayjs().tz(localTimeZone)
    const formattedTime = departNow ? currentTimeInLocalTimeZone.format('YYYY-MM-DDTHH:mm:ss') : updateDepartTime.format('YYYY-MM-DDTHH:mm:ss')
    console.log('departTimeTestformattedTime:', formattedTime)
  
    const token = localStorage.getItem('token')
    console.log('departTimeTestformattedTime:', formattedTime)
    const payload = {
      startLocation: {
        lat: fromLat,
        lng: fromLong
      },
      endLocation: {
        lat: toLat,
        lng: toLong
      },
      departureTime: formattedTime, // ('2025-03-30T17:32:47') once time zone enable in google APIs make "departureTime", "departureTimeOffset" and "arrivalTimeOffset" dynamic
      selectedTripIndex: alternativeRoute,
      team: teamParam === undefined ? false : teamParam,
      speed: {
        speedUnit: 'MPH',
        value: Number(speedChange) || 35.0
      },
      departureTimeOffset: '+05:30', // make departureTimeOffset field dynamic use state --> utcFromOffset
      arrivalTimeOffset:  '+05:30'  // make arrivalTimeOffset field dynamic use state --> utcToOffset
    }
    const { success, data, error } = await ApiService.makeApiCall(
      TRIP_SUMMARY_URL,
      'POST',
      payload,
      token,
      null
    )
    if (success) {
      const {
        arrivalTimeInUTC,
        arrivalTimeOffset,
        departureTimeInUTC,
        departureTimeOffset
      } = data

      // chaange utc to local timezone
      const localTimeZone = dayjs.tz.guess()
      console.log('localTimeZone', localTimeZone)
      const arrivalTimeInLocalTimeZone = dayjs(arrivalTimeInUTC).tz(localTimeZone)
      const departureTimeInLocalTimeZone = dayjs(departureTimeInUTC).tz(localTimeZone)
      setArrivalTime(arrivalTimeInLocalTimeZone)
      setDepartTime(departureTimeInLocalTimeZone)

      // Set alternative route for specific details
      if (data) {
        data.alternativeRoute = alternativeRoute
        localStorage.setItem('breaksNRestDetails', JSON.stringify(data))
        setSelectedRouteDetailsSubmit(data)
      }
      setSelectPathIndex(updatedRouteForMap)
      showToast('Departure and arrival time updated sucessfully', 'success')
    } else {
      console.log('Error:', error)
      showToast(error + `Time should be grater than current time`, 'error')
    }
  }

  useEffect(()=> {
    const storedData = localStorage.getItem('breaksNRestDetails')
    const parsedData = JSON.parse(storedData)
    if(parsedData !== null){
      setTimeout(()=>{
        setSelectedRouteDetailsSubmit(parsedData)
      },1000)
    }
  },[isTableGetSummary])

  const handleRouteChoose = (event) => {
    const {
      target: { value }
    } = event
    const updatedRoute = value === 'Default' ? 0 : value === 'All' ? '' : value
    const updatedRouteForMap =
      value === 'Default' ? 0 : value === 'All' ? -1 : value
    // setSelectPathIndex(updatedRouteForMap)
    setUpdateRouteTeamCheckbox({
      ...updateRouteTeamCheckbox,
      updatedRoute,
      updatedRouteForMap
    })
    getSummaryOfRoute(updatedRoute, updatedRouteForMap)
    setRouteChoose(value)
  }

  const onTeamCheckboxChange = (team) => {
    setTeam(!team)
    const teamParam = !team
    getSummaryOfRoute(
      updateRouteTeamCheckbox?.updatedRoute,
      updateRouteTeamCheckbox?.updatedRouteForMap,
      teamParam
    )
    // store team in localstorage
    // localStorage.setItem('team',!team)
  }

  return (
    <>
      <div className="gps_createTrip_overlay">
        <Modal open={isTableVisible} onClose={''}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              right: 0, // Aligns to the right
              transform: 'translateY(-50%)', // Centers vertically
              width: '30vw', // Adjust width as needed
              minWidth: '300px',
              bgcolor: 'background.paper',
              boxShadow: 24,
              p: 3,
              borderRadius: '4px',
              paddingBottom: '10px',
              ml: 'auto', // Ensures content stays aligned to the right
              height: '100vh'
            }}
          >
            <IconButton
              edge="end"
              onClick={handleClose}
              sx={{ position: 'absolute', top: 10, right: 10 }}
            >
              <CloseIcon />
            </IconButton>

            <Typography
              variant="h6"
              sx={{
                textAlign: 'left',
                fontWeight: '500',
                fontSize: '20px',
                paddingBottom: '10px',
                borderBottom: '1px solid #E5E5E5',
                marginBottom: '10px'
              }}
            >
              Create Trip
            </Typography>

            <div style={{ flex: 1 }}>
              <label className="label-of-create-trip">
                From Address<span className="text-danger">*</span>
              </label>
              <FromSearchBar
                setLat={setFromLat}
                setLong={setFromLong}
                setAddress={setFromAddress}
                inputValue={inputValue}
                setInputValue={setInputValue}
                handleInputChange={handleInputChange}
                setUtcFromOffset={setUtcFromOffset}
                setFromOffsetFromUtcInMs={setFromOffsetFromUtcInMs}
                setFromTimeZone={setFromTimeZone}
                setDepartTime={setDepartTime}
                label="From Address"
                style={{
                  width: '80vw !important',
                  background: 'white !important'
                }}
              />
            </div>
            <div
              style={{
                margin: '10px 0 15px 0',
                width: '80vw !important',
                background: 'white !important'
              }}
            >
              <label className="label-of-create-trip">
                To Address<span className="text-danger">*</span>
              </label>
              <ToSearchBar
                setLat={setToLat}
                setLong={setToLong}
                setAddress={setToAddress}
                inputValue={inputValue}
                setInputValue={setInputValue}
                setUtcToOffset={setUtcToOffset}
                setToOffsetFromUtcInMs={setToOffsetFromUtcInMs}
                setToTimeZone={setToTimeZone}
                handleInputChange={handleInputChange}
                label="To Address"
                style={{
                  width: '80vw !important',
                  background: 'white !important'
                }}
              />
              {error && <p className="error">{error}</p>}
            </div>

            <div className='d-flex gap-3 align-items-center my-4'>
              <label className="label-of-create-trip">
                Speed(MPH)<span className="text-danger">*</span>
              </label>
              <TextField
                id="outlined-basic"
                variant="outlined"
                type="number"
                inputProps={{ min: 0 }}
                value={speedChange}
                onChange={(e) => setSpeedChange(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    height: '36px', // Reduce height
                    width: '100%',
                    borderRadius: '4px',
                    fontSize: '14px', // Adjust text size
                    '& input': {
                      padding: '8px 12px' // Reduce padding inside input field
                    },
                    '& fieldset': {
                      borderColor: '#ccc' // Default border color
                    },
                    '&:hover fieldset': {
                      borderColor: '#a3a3a3b3', // Border color on focus
                      borderWidth: '0.3px' // Border color on hover // Border color on hover
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#a3a3a3b3', // Border color on focus
                      borderWidth: '0.3px'
                    }
                  }
                }}
              />
            </div>

            <FormControlLabel
              control={
                <Checkbox
                  checked={departNow}
                  onChange={() => setDepartNow(!departNow)}
                  sx={{
                    color: '#A3A3A3',
                    '&.Mui-checked': {
                      color: '#2C6FEB'
                    },
                    width: '40px', // Set width to 20px
                    height: '40px', // Set height to 20px
                    '& .MuiSvgIcon-root': {
                      fontSize: '20px' // Ensures the checkbox icon scales correctly
                    },
                    padding: '4px' // Reduce padding to fit the smaller size
                  }}
                />
              }
              label="Depart Now"
              sx={{
                '& .MuiFormControlLabel-label': {
                  fontFamily: "'Poppins', sans-serif !important",
                  letterSpacing: '0px !important',
                  color: '#858585 !important',
                  fontSize: '12px',
                  border: '0.3px'
                }
              }}
            />

            <FormControl fullWidth style={{ marginBottom: '5px' }}>
              <label className="label-of-create-trip">
                Select Route<span className="text-danger">*</span>
              </label>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={routeChoose}
                onChange={handleRouteChoose}
                disabled={!fromAddress || !toAddress}
                input={
                  <OutlinedInput
                    sx={{
                      height: '36px',
                      fontFamily: "'Poppins', sans-serif !important",
                      fontWeight: '400 !important',
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#ccc', // Default border color
                        borderRadius: '4px',
                        borderWidth: '0.3px'
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#A3A3A3', // Border color on hover
                        borderRadius: '4px',
                        borderWidth: '0.3px'
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#A3A3A3', // Border color on focus (click)
                        borderRadius: '4px',
                        borderWidth: '0.3px'
                      },
                      fontFamily: "'Poppins', sans-serif",
                      fontSize: '16px'
                    }}
                  />
                }
                MenuProps={MenuProps}
              >
                {/* Default Route */}
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Default">Default</MenuItem>

                {/* Mapping Over Alternatives */}
                {Array.from(
                  { length: multipleRoutes.alternatives },
                  (_, index) => (
                    <MenuItem key={index + 1} value={index + 1}>
                      Alternative {index + 1}
                    </MenuItem>
                  )
                )}
              </Select>
            </FormControl>

            {!departNow && (
              <div
                style={{
                  width: isMobile ? '85vw' : 'calc(100% - 3px)'
                }}
                className="date-picker-main"
              >
                <div className="d-flex align-items-center gap-1">
                  <label className="label-of-create-trip">
                    Depart Time<span className="text-danger">*</span>({fromTimeZone})
                  </label>
                  {/* <span className="label-of-create-trip">{fromTimeZone ? `(${fromTimeZone})` : ''}</span> */}
                </div>

                <DepartureDateTimeFieldValue
                  value={departTime}
                  title={'Depart Time'}
                  isDisable={false}
                  setValue={setDepartTime}
                  departureTimezone={fromTimeZone}
                />
                {error && <p className="error">{error}</p>}
              </div>
            )}

            <div
              style={{
                margin: '7px 0 5px 0',
                width: isMobile ? '85vw' : 'calc(100% - 3px)'
              }}
            >
              <div className="d-flex align-items-center gap-1">
                <label className="label-of-create-trip-arrival-time">
                  Arrival Time<span className="text-danger">*</span>({toTimeZone})
                </label>
                {/* <span className="label-of-create-trip-arrival-time">{toTimeZone ? `(${toTimeZone})` : ''}</span> */}
              </div>
              <ArrivalDateTimeFieldValue
                value={arrivalTime}
                title={'Arrival Time'}
                isDisable={false}
                setValue={setArrivalTime}
                arrivalTimezone={toTimeZone}
              />
              {error && <p className="error">{error}</p>}
            </div>

            <div className="d-flex justify-content-between">              

              <FormControlLabel
                control={
                  <Checkbox
                    checked={team}
                    onChange={() => onTeamCheckboxChange(team)}
                    disabled={routeChoose === 'All' ? true : false}
                    sx={{
                      color: '#A3A3A3',
                      '&.Mui-checked': {
                        color: '#2C6FEB'
                      },
                      width: '40px', // Set width to 20px
                      height: '40px', // Set height to 20px
                      '& .MuiSvgIcon-root': {
                        fontSize: '20px' // Ensures the checkbox icon scales correctly
                      },
                      padding: '4px' // Reduce padding to fit the smaller size
                    }}
                  />
                }
                label="Team"
                sx={{
                  '& .MuiFormControlLabel-label': {
                    fontFamily: "'Poppins', sans-serif !important",
                    letterSpacing: '0px !important',
                    color: '#858585 !important',
                    fontSize: '12px',
                    border: '0.3px'
                  }
                }}
              />
              
              <div style={{ margin: '0' }}>
                <Button
                  onClick={handleCreateTripClick}
                  style={{
                    cursor: 'pointer',
                    width: '95px',
                    textAlign: 'center',
                    float: 'right',
                    backgroundColor:
                      routeChoose === 'All' ? '#A5D6A7' : '#00cc00',
                    color: 'white',
                    marginRight: '2px',
                    marginTop: '5px',
                    borderRadius: '4px',
                    fontSize: '12px',
                    height: '35px',
                    textTransform: 'capitalize',
                    fontFamily: "'Poppins', sans-serif !important"
                  }}
                  disabled={routeChoose === 'All' || !departTime || !arrivalTime}
                >
                  {isLoading && (
                    <span
                    class="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  )}
                  Add Trip
                </Button>
                {error && <p className="error">{error}</p>}
              </div>
            </div>

            {/* <div style={{ margin: '0' }}>
              {isLoading ? <CircularProgress sx={{ color: '#212529' }} /> : ''}
            </div> */}
          </Box>
        </Modal>
      </div>
    </>
  )
}
export default CreateTripDialog
